<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form @submit.prevent="load">
          <b-form-row class="align-items-center">
            <lg-form-input v-model="form.descricao" label="Descrição:" cols="12" sm="8" md="10" />
            <b-button class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary" @click="load()">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
            </b-button>
          </b-form-row>
        </b-form>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="statusSelect">
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button :id="'editar-' + item.id" class="my-2 mx-2" size="sm" pill variant="primary"
              @click="abrirModalEdit(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" />
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total" align="right"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"

export default {
  components: {
    LgFormInput,
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      codigoEmpresa: this.codEmpresa || null,
      form: {
        descricao: "",
      },
    }
  },
  props: {
    tipo: {
        type:Number,
        default:null
    },
    prefix: {
      Array,
      default: () => [],
    },
  },
  mixins: [ListResourceMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/status/tipo/${this.tipo != null?this.tipo: 6}`)
  },
  mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    tableFields() {
      return [
        { key: "descricao", label: "Descrição" },
      ]
    },
  },
  methods: {
    async load() {
      this.filtro = {}

      if (this.form.descricao) {
        this.filtro.descricao = this.form.descricao
      }

      this.busy = true
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      })
    },
    cancelar() {
      this.showModalEdit = false
      this.id = null
      this.nomeEmpresa = ""
      this.codigoEmpresa = null
      this.load()
    },
    abrirModalEdit(item) {
      this.id = item.id
      this.nomeEmpresa = item.razaoSocial
      this.showModalEdit = true
    },
    statusSelect(item) {
      this.$emit("onDblClickStatusSelect", item)
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " +
        (item.situacao === 1 ? "ativar" : "desativar") +
        " o Status?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item)
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },
  },
}
</script>
